import { useState, useCallback } from "react";
import { useScopeId } from "@core/hooks/useRouteParamId";
import { FinanceCategoryCalcTypeOption } from "@features/admin/finance/category/types/financeCategory";
import { fetchFinanceCategoryCalcTypesAsync } from "@features/admin/finance/category/services/financeCategorySvc";

export function useFinanceCategoryOptions() {
    const resolvedNationId = useScopeId() ?? 0;

    const [calcTypes, setCalcTypes] = useState<FinanceCategoryCalcTypeOption[]>([]);
    const [calcTypesLoading, setCalcTypesLoading] = useState(false);
    const [calcTypesError, setCalcTypesError] = useState<string | null>(null);

    const fetchCalcTypes = useCallback(async () => {
        let cancelled = false;
        setCalcTypesLoading(true);
        setCalcTypesError(null);
        try {
            const response = await fetchFinanceCategoryCalcTypesAsync(resolvedNationId);
            if (!cancelled) {
                setCalcTypes(response.getData() ?? []);
            }
        } catch (e: any) {
            if (!cancelled) {
                setCalcTypesError(e?.message ?? "Failed to load calculation types.");
            }
        } finally {
            if (!cancelled) {
                setCalcTypesLoading(false);
            }
        }
        return () => { cancelled = true; };
    }, [resolvedNationId]);

    return { calcTypes, calcTypesLoading, calcTypesError, fetchCalcTypes };
}
